import { makeStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) => {
  return {
    root: {
      "@media print": {
        "& .no-print": {
          display: "none"
        }
      }
    },
    scanner: {
      "& > div": {
        flex: 1
      }
    },
    manualInput: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1)
    },
    manualInputLabel: {
      marginTop: theme.spacing(1),
      paddingLeft: 10
    },
    field: {
      display: "flex",
      justifyContent: "center",
      marginBottom: theme.spacing(2)
    },
    productDescriptionEditor: {
      minHeight: 250,
      "& .quill": {
        height: "100%",
        "& .ql-container": {
          height: "70%"
        }
      }
    },
    productTypeList: {
      "& .MuiListItem-gutters": {
        paddingLeft: 0
      }
    }
  };
});
